import Clickable from "@components/clickable";
import { StyledField, StyledFieldContent } from "@components/inputs/field/Field.styles";
import styled from "styled-components";

import { T_PLAIN_big, T_PLAIN_small } from "../../../../global.style";

export const ClickableStyled = styled(Clickable)<{
    $withoutMargin?: boolean;
    $isBig?: boolean;
}>`
    ${props => props.$isBig ? T_PLAIN_big : T_PLAIN_small}
    ${props => props.$withoutMargin ? "" : "margin-bottom: 30px;"}
    display: flex;
`;

export const TableWrapper = styled.div`
    max-height: 700px;
    margin-bottom: 20px;
`;

export const AlertWrapper = styled.div`
    &:not(:empty) {
        margin-bottom: 10px;
    }
`;

export const Subtitle = styled.div`
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 19px;
`;

export const Text = styled.div`
    ${T_PLAIN_big}
    margin-bottom: 19px;
`;

export const DataGrid = styled.div`
    display: grid;
    grid-template-columns: max-content max-content;
    gap: 10px 20px;
    max-width: 100%;
    overflow-x: auto;
    margin-bottom: 30px;
`;

export const LinksWrapper = styled.div`
    display: flex;
    gap: 30px;
`;

export const DataGridCell = styled.div<{
    $isBold?: boolean;
    $columnSpan?: number;
    $hasExtraTopMargin?: boolean;
    $isValueCell?: boolean;
}>`
    ${T_PLAIN_big}
    font-weight: ${props => props.$isBold ? "bold" : "normal"};
    grid-column: span ${props => props.$columnSpan ?? 1};
    margin-top: ${props => props.$hasExtraTopMargin ? "20px" : "0"};
    ${props => props.$isValueCell ? `
        text-align: right;
        padding-right: 12px;
    ` : ""}
    ${StyledField} {
        margin-right: 0;
        ${StyledFieldContent} {
            justify-content: flex-end;
        }
    }
`;

export const UnitStyled = styled.span`
    color: ${props => props.theme.C_ACT_thick_line};
`;